// This file was originally created by Team RED.
// We just made some modifications to make it work for us.
import { errorLandingPages, logLandingPages, warnLandingPages } from "../logging/logging";
var eventHandler = function () {
    var addEventListener = function (element, type, handler) {
        if (element.addEventListener) {
            element.addEventListener(type, handler);
        }
        else {
            if (/domcontentloaded/i.test(type)) {
                type = "load";
            }
            element.attachEvent("on" + type, handler);
        }
    };
    return {
        addEventListener: addEventListener,
    };
};
// tslint:disable-next-line:max-func-body-length
var messageHandler = function (handler, trustedDomains, targetWindow) {
    var events = {};
    var messageCounter = 0;
    var register = function () {
        logLandingPages("MessageHandler::register");
        handler.addEventListener(window, "message", function (event) {
            if (event.data.type === "webpackOk" || event.data.type === "webpackInvalid") {
                return;
            }
            try {
                var payload_1 = getDataFrom(event);
                var isJson = payload_1.constructor === {}.constructor;
                if (!isTrustedSource(event.origin)) {
                    return;
                }
                if (!isJson) {
                    return;
                }
                //  invoke the required function
                var returnedPromise = execute(payload_1);
                if (!payload_1.callback) {
                    return;
                }
                // send a message back with the returned Value in order for the original caller to trigger the callback
                Promise.resolve(returnedPromise)
                    .then(function (returnValue) {
                    var response = {
                        arguments: returnValue,
                        name: payload_1.callback,
                        type: "gameClient",
                    };
                    targetWindow.postMessage(response, "*");
                })
                    .catch(function (reason) {
                    errorLandingPages("something went wrong while sending back the callback", reason);
                });
            }
            catch (e) {
                warnLandingPages("MessageHandler:: on message caught error: ", e.message);
            }
        });
    };
    var isTrustedSource = function (origin) {
        return trustedDomains.some(function (val) { return val === origin; });
    };
    var getDataFrom = function (event) {
        var data = event.data;
        if (data.constructor === "test".constructor) {
            try {
                data = JSON.parse(data);
            }
            catch (err) {
                warnLandingPages("Unable to parse JSON data:", data, err);
            }
        }
        return data;
    };
    var addEvent = function (name, callback) {
        events[name] = callback;
    };
    var execute = function (payload) {
        if (payload.name === undefined) {
            return;
        }
        var method = window[payload.name] || events[payload.name];
        if (!method) {
            errorLandingPages("PageIntegration method not found: " + payload.name);
            return;
        }
        if (!payload.arguments && payload.arguments !== false) {
            return method();
        }
        if (Array.isArray(payload.arguments) && method.length === payload.arguments.length) {
            return method.apply(undefined, payload.arguments);
        }
        return method(payload.arguments);
    };
    /**
     * Wraps original function name and parameters into an object that is sent via postMessage to the parent window
     * it also register a callback that will be executed as soon as we receive a postMessage back from the parent window with the result (to keep old callback beahviour in place)
     * it isn't as arrow function because arguments not works for arrow function
     * @param name
     * @param arguments
     */
    function sendMessage(name) {
        var params = Array.prototype.slice.call(arguments, sendMessage.length);
        // we assume in the old implementation callbacks were always passed as last param.
        // we grab it and remove it from param list (we dont want /  cant transfer it to the target - we just want to execute it once the target replies with another message)
        var callback = params[params.length - 1] instanceof Function ? params.pop() : undefined;
        var data = {
            arguments: params,
            name: name,
            type: "gameClient",
        };
        if (callback) {
            var callbackName = "callbackOf_" + name + "_" + ++messageCounter;
            data.callback = callbackName;
            registerCallback(callback, callbackName);
        }
        targetWindow.postMessage(data, "*");
        logLandingPages("SendMessage::", data.name);
    }
    var registerCallback = function (callbackFunction, callbackName) {
        window[callbackName] = function (response) {
            logLandingPages("Executing callback", callbackName);
            callbackFunction(response);
            try {
                delete window[callbackName];
            }
            catch (e) {
                errorLandingPages("registerCallback :: Can't delete callback from window: " + callbackName);
            }
            window[callbackName] = undefined;
        };
    };
    return {
        addEvent: addEvent,
        register: register,
        sendMessage: sendMessage,
    };
};
export var MessageHandler = messageHandler;
export var EventHandler = eventHandler;



//////////////////
// WEBPACK FOOTER
// ./src/utils/landing-page/utilLandingPage.ts
// module id = 1684
// module chunks = 3